import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function BotStartsMiniChart({ data = [] }) {
    const labels = data.map(item => item.date);
    const values = data.map(item => item.count);

    // Cores do tema (useTheme.js): cor padrão e a versão mais escura
    const rootStyles = getComputedStyle(document.documentElement);
    const purple = rootStyles.getPropertyValue('--purple').trim() || '#8b5cf6';
    const purpleDark = rootStyles.getPropertyValue('--purple-dark').trim() || '#691dec';

    const chartData = {
        labels,
        datasets: [
            {
                data: values,
                // Cor padrão para as barras, cor mais escura para o último item (destaque)
                backgroundColor: data.map((_, index) =>
                    index === data.length - 1 ? purpleDark : purple
                ),
                borderColor: purple,      // pode ser string simples
                borderWidth: 1,            // 👈 ISSO AQUI É O QUE FALTA

                minBarLength: 2, // 👈 altura mínima em pixels
                borderRadius: 4,
                categoryPercentage: 1.0,  // Remove espaço entre grupos
                barPercentage: 1.0,       // Remove espaço interno entre barras
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                displayColors: true,
                usePointStyle: true,
                callbacks: {
                    label: (context) => ` ${context.raw} iniciações`
                }
            }
        },
        scales: {
            x: {
                display: false, // Opcional: ocultar eixo X para um visual mais "mini" e limpo
                grid: { display: false },
            },
            y: {
                display: false,
                beginAtZero: true,
                grid: { display: false }
            }
        },
        // Remove paddings extras do layout do Chart.js
        layout: {
            padding: 0
        }
    };

    return (
        <div style={{ height: 80, width: '100%' }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}
